import React, {
  useRef,
  useState,
  useImperativeHandle,
  useCallback,
} from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  DialogActions,
  Button,
  CircularProgress,
} from '@material-ui/core';
import { Form } from '@unform/web';
import axios from 'axios';
import { isFunction, isArray } from 'lodash';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { t } from '~/helpers';

import { Container } from './styles';

const Report = React.forwardRef((props, ref) => {
  const {
    open,
    onClose,
    title,
    children,
    confirm,
    cancel,
    relatorio,
    serialize,
    initials,
    validate,
    maxWidth,
    requestType,
  } = props;

  const formRef = useRef(null);
  const mobile = window.innerWidth <= 768;

  const { token } = useSelector((state) => state.auth);

  const [loading, setLoading] = useState(false);

  async function handleSubmit(param) {
    try {
      setLoading(true);

      formRef.current.setErrors({});

      const REACT_APP_URL_DOWNLOAD = sessionStorage.getItem('URL_REPORT');

      await validate(param);

      const forms = isFunction(serialize) ? serialize(param) : param;

      const url = new URL(REACT_APP_URL_DOWNLOAD);
      url.search = new URLSearchParams({
        relatorio,
        token,
        ...JSON.parse(JSON.stringify(forms)),
      });

      const response = async () => {
        if (requestType == 'POST' || requestType == 'PUT') {
          const res = await axios({
            url: `${REACT_APP_URL_DOWNLOAD}/${relatorio}`,
            method: requestType,
            responseType: 'blob',
            headers: {
              token,
            },
            data: {
              ...forms,
            },
          });

          return res;
        }

        const res = await axios({
          url: url.href,
          method: requestType,
          responseType: 'blob',
        });

        return res;
      };

      const { data } = await response();

      const file = new Blob([data], { type: data.type });

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(file);
      } else {
        const objectUrl = URL.createObjectURL(file);
        window.open(objectUrl);
      }

      // const file = new Blob([data], { type: data.type });

      // window.open(URL.createObjectURL(file));
    } catch (err) {
      console.log('ERR', err);
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message;
        });

        formRef.current.setErrors(validationErrors);
      } else if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    } finally {
      setLoading(false);
    }
  }

  const handleClear = useCallback((field) => {
    formRef.current.setFieldValue(field, '');
  }, []);

  const handleFieldValue = useCallback((field) => {
    formRef.current.getFieldValue(field);
  }, []);

  useImperativeHandle(ref, () => ({
    handleClear,
    handleFieldValue,
  }));

  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      fullWidth
      maxWidth={maxWidth}
      open={open}
      onClose={onClose}
      fullScreen={mobile}
    >
      <DialogTitle>
        <Typography variant="h6">{title}</Typography>
      </DialogTitle>
      <DialogContent>
        <Form ref={formRef} onSubmit={handleSubmit} initialData={initials}>
          <Container>{children}</Container>
        </Form>
      </DialogContent>
      <DialogActions>
        {loading ? (
          <CircularProgress
            size={20}
            color="primary"
            style={{ marginRight: '1.5rem' }}
          />
        ) : (
          <Button
            loading
            onClick={() => formRef.current.submitForm()}
            color="primary"
            variant="outlined"
          >
            {mobile ? 'Download' : confirm}
          </Button>
        )}

        <Button onClick={() => onClose()} color="secondary" variant="outlined">
          {cancel}
        </Button>
      </DialogActions>
    </Dialog>
  );
});

Report.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  children: PropTypes.element.isRequired,
  confirm: PropTypes.string,
  cancel: PropTypes.string,
  relatorio: PropTypes.string.isRequired,
  serialize: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  initials: PropTypes.objectOf(PropTypes.any),
  validate: PropTypes.func,
  maxWidth: PropTypes.string,
  requestType: PropTypes.oneOfType(['GET', 'POST', 'PUT', 'DELETE', 'UPDATE']),
};

Report.defaultProps = {
  open: false,
  title: 'Unidata',
  confirm: 'Exibir',
  cancel: 'Cancelar',
  serialize: false,
  initials: {},
  validate: async () => {},
  maxWidth: 'sm',
  requestType: 'GET',
};

export default Report;
